import React from "react";
import {
  Box,
  Card,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip
} from "@mui/material";

const ScopeAccreditation = ({ data, labType }) => {
  if (!data || data.length === 0) return null;
  // GROUP DATA BY ASSESSOR + DISCIPLINE
  const groupedData = data.reduce((acc, item) => {
    const key = `${item.AssessorName}_${item.disciplineName}`;

    if (!acc[key]) {
      acc[key] = {
        assessor: item.AssessorName,
        discipline: item.disciplineName,
        scopes: []
      };
    }

    acc[key].scopes.push(item);
    return acc;
  }, {});

  // Maintain continuous serial number across all groups
  let serialNumber = 0;

  return (
   <Box sx={{ mb: 4 }}>
      <Card elevation={3}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            bgcolor: "#e3f2fd",
            p: 1,
            mb: 2,
            textAlign: "center"
          }}
        >
          Scope of Accreditation (Form 72)
        </Typography>

        {Object.values(groupedData).map((group, gIndex) => (
          <Box key={gIndex} sx={{ mb: 3, px: 2 }}>

            {/* ASSESSOR + DISCIPLINE HEADER */}
            <Typography sx={{ fontWeight: "bold", mb: 0.5 }}>
              Assessor: {group.assessor || "-"}
            </Typography>

            <Typography sx={{ fontWeight: "bold", mb: 1 }}>
              Discipline: {group.discipline || "-"}
            </Typography>

            <TableContainer component={Paper}>
              <Table
                size="small"
                sx={{
                  border: "1px solid #bdbdbd",
                  "& th, & td": { border: "1px solid #bdbdbd" },
                  borderCollapse: "collapse"
                }}
              >
                <TableHead>
                  <TableRow sx={{ bgcolor: "#dbd8d8c7" }}>
                    <TableCell align="center"><b>Sr No.</b></TableCell>
                    <TableCell align="center"><b>Scope Details</b></TableCell>
                    <TableCell align="center"><b>Range & Standards</b></TableCell>
                    <TableCell align="center"><b>Assessment Details</b></TableCell>
                    <TableCell align="center"><b>Status</b></TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {group.scopes.map((item, index) => {
                    serialNumber++; // Increment serial number for each scope
                    return (
                      <TableRow key={index}>
                        <TableCell align="center">{serialNumber}</TableCell>

                        <TableCell>
                          <div>
                            <strong>Test Code:</strong> {item.testCode || "-"}
                          </div>
                          <div>
                            <strong>Materials:</strong>{" "}
                            {item.GroupTested || "-"}
                          </div>
                          <div>
                            <strong>Test Performed:</strong>{" "}
                            {item.TypeOfTest || "-"}
                          </div>
                          <div>
                            <strong>Method:</strong> {item.scopeStandard || "-"}
                          </div>
                        </TableCell>

                        <TableCell>
                          <div>
                            <strong>Type:</strong> {item.rangeType || "-"}
                          </div>
                          <div>
                            <strong>Facility:</strong>{" "}
                            {item.testPerformedAt || "-"}
                          </div>
                          <div>
                            <strong>Range:</strong> {item.unit || "-"}
                          </div>
                          {/* <div><strong>%CV:</strong> CV:{item.cv || "-"}</div> */}
                          {item.rangeType === "Calculative" ||
                          item.rangeType === "Calculated" ||
                          item.scopeStandard
                            ?.toLowerCase()
                            .includes("calculated") ? (
                            ""
                          ) : (
                            <div>
                              <strong>%CV:</strong> {item.cv || "-"}
                            </div>
                          )}
                        </TableCell>
                        <TableCell>
                          <div>
                            <strong>Assessment Technique:</strong>{" "}
                            {item.assessmentTechniqueUsed ||
                              item.scopeStandard ||
                              "-"}
                          </div>
                          {item.Remarks && (
                            <div>
                              <strong>Remarks:</strong> {item.Remarks}
                            </div>
                          )}
                        </TableCell>

                        <TableCell align="center">
                          <Chip
                            label={item.status || "N/A"}
                            size="small"
                            sx={{
                              backgroundColor:
                                item.status === "Adequate"
                                  ? "#4caf50"
                                  : item.status === "Inadequate"
                                    ? "#f44336"
                                    : item.status === "Not Applicable"
                                      ? "#ff9800"
                                      : "#9e9e9e",
                              color: "#fff",
                              fontWeight: 700,
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

          </Box>
        ))}
      </Card>
    </Box>
  );
};

export default ScopeAccreditation;
